import { Link } from "gatsby"
import React, { useState } from "react"
import * as style from "./style.module.css"
import logo from "/src/images/common/logo.svg"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleRight } from "@fortawesome/free-solid-svg-icons"

const Component = () => {
  const menu = [
    { title: "ホーム", link: "/" },
    { title: "採用情報", link: "/recruit" },
    { title: "事業内容", link: "/business" },
    { title: "取引の流れ", link: "/flow" },
    { title: "お知らせ", link: "/articles/p/1" },
    { title: "会社情報", link: "/about" },
    { title: "お問い合わせ", link: "/contact" },
  ]

  return (
    <header>
      <div className={style.headerLeftWrapper}>
        <div className={style.headerLeftLogo}>
          <Link to="/">
            <img src={logo} alt="株式会社新翔" />
          </Link>
        </div>
      </div>
      <div className={style.headerRightWrapper}>
        <div className={style.hamNav}>
          <input
            id={style.drawer_input}
            className={style.drawer_hidden}
            type="checkbox"
          />
          <label htmlFor={style.drawer_input} className={style.drawer_open}>
            <span></span>
          </label>

          <nav className={style.hamNav_content}>
            <div className={style.hamNav_line} />
            <img className={style.hamNavLogo} src={logo} alt="株式会社新翔" />
            <ul className={style.hamNav_list}>
              {menu.map(elm => (
                <li className={style.hamNav_item} key="headerLink">
                  <Link to={elm.link}>
                    <span className={style.hamNav_itemTitle}>{elm.title}</span>
                    <FontAwesomeIcon
                      className={style.hamNav_itemIcon}
                      icon={faCircleRight}
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Component
